var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9791 39.6C28.0324 39.6 26.2991 39.2067 24.7791 38.42C23.2724 37.62 22.0857 36.5267 21.2191 35.14C20.3657 33.74 19.9391 32.1467 19.9391 30.36C19.9391 28.84 20.2791 27.4067 20.9591 26.06C21.6524 24.7133 22.6457 23.6133 23.9391 22.76L23.8191 24.44C22.8457 23.4933 22.0791 22.4933 21.5191 21.44C20.9724 20.3867 20.6991 19.2 20.6991 17.88C20.6991 16.2133 21.0924 14.76 21.8791 13.52C22.6791 12.28 23.7724 11.32 25.1591 10.64C26.5591 9.94667 28.1657 9.6 29.9791 9.6C31.7924 9.6 33.3924 9.94667 34.7791 10.64C36.1791 11.32 37.2724 12.28 38.0591 13.52C38.8591 14.76 39.2591 16.2133 39.2591 17.88C39.2591 19.2 38.9991 20.3867 38.4791 21.44C37.9591 22.48 37.1657 23.4933 36.0991 24.48V22.8C37.3657 23.6 38.3391 24.68 39.0191 26.04C39.7124 27.4 40.0591 28.84 40.0591 30.36C40.0591 32.1467 39.6257 33.74 38.7591 35.14C37.8924 36.5267 36.6991 37.62 35.1791 38.42C33.6591 39.2067 31.9257 39.6 29.9791 39.6ZM29.9791 34.48C31.2591 34.48 32.2991 34.1333 33.0991 33.44C33.8991 32.7467 34.2991 31.72 34.2991 30.36C34.2991 29.0133 33.8991 27.9867 33.0991 27.28C32.2991 26.56 31.2591 26.2 29.9791 26.2C28.6991 26.2 27.6657 26.56 26.8791 27.28C26.0924 27.9867 25.6991 29.0133 25.6991 30.36C25.6991 31.72 26.0924 32.7467 26.8791 33.44C27.6657 34.1333 28.6991 34.48 29.9791 34.48ZM29.9791 21.04C31.0191 21.04 31.8657 20.7867 32.5191 20.28C33.1724 19.76 33.4991 18.96 33.4991 17.88C33.4991 16.8 33.1724 16 32.5191 15.48C31.8657 14.9467 31.0191 14.68 29.9791 14.68C28.9391 14.68 28.0924 14.9467 27.4391 15.48C26.7857 16 26.4591 16.8 26.4591 17.88C26.4591 18.96 26.7857 19.76 27.4391 20.28C28.0924 20.7867 28.9391 21.04 29.9791 21.04Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 51.0059C25.5612 43.2841 14.25 46.3057 14.25 53.8932C14.25 62.4208 25.9908 65.4424 29.9282 73.3657L29.9998 73.5L30.0714 73.3657C34.0089 65.4424 45.7497 62.4208 45.7497 53.8932C45.8213 46.3057 34.4384 43.2841 29.9998 51.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8H);
export default __webpack_public_path__ + "static/media/8h.5ebcc1094b4ecfeafac9092edc6f67f9.svg";
export { ForwardRef as ReactComponent };